/**
 * Recorte que a Meta entende (SPEC 4.3, 3.3). A Meta só recorta o investimento por conta, campanha,
 * conjunto e anúncio; pagamento, produto, dispositivo, posicionamento, origem e respostas do quiz são
 * dimensões da Kiwify e do tracker. Contas puras, usadas pelas telas (o Tráfego reexporta em
 * `features/trafego/metaFilters.ts`) e pela camada de dados (`data/metaCut.ts`: no modo ao vivo, MER,
 * lucro e CPA com um desses filtros misturariam vendas recortadas com o gasto da conta inteira).
 */
import type { Filters } from '@rota/contracts';

/** Dimensões fora da Meta, na ordem do painel de filtros. */
export type OffMetaDim = 'pag' | 'prod' | 'disp' | 'pos' | 'utm' | 'quiz';

/** Só conta, campanha, conjunto e anúncio. */
export function metaOnly(f: Filters): Filters {
  const out: Filters = {};
  if (f.accountIds?.length) out.accountIds = f.accountIds;
  if (f.campaignIds?.length) out.campaignIds = f.campaignIds;
  if (f.adsetIds?.length) out.adsetIds = f.adsetIds;
  if (f.adIds?.length) out.adIds = f.adIds;
  return out;
}

/** Quais dimensões ativas a Meta não recorta (vazio = nada a avisar). */
export function offMetaDims(f: Filters): OffMetaDim[] {
  const dims: OffMetaDim[] = [];
  if (f.paymentMethods?.length) dims.push('pag');
  if (f.products?.length) dims.push('prod');
  if (f.devices?.length) dims.push('disp');
  if (f.placements?.length) dims.push('pos');
  if (f.utmSources?.length) dims.push('utm');
  if (f.quiz?.some((q) => q.optionIds.length > 0)) dims.push('quiz');
  return dims;
}
